import _ from 'lodash';
import { routeCreator } from '@adrias-online/steiner/lib/helpers';

import { selectors } from '../reducers/portaliArticoli';
import routeRegister from '../../../helpers/routeRegister';
import { generateRoutes } from '../../../helpers/portaleModuleHelper';

const routes = generateRoutes('articoli', selectors);

const list = _.values(routes.list).map(route => ({
    ...route,
    getComponent() {
        return new Promise(resolve => {
            import(/* webpackChunkName: 'portaliArticoli' */ `modules/portaliArticoli/${
                route.componentPath
            }`).then(response => resolve(response.default));
        });
    }
}));

const links = routeCreator.generateLinks(routes.patterns);

routeRegister.addPatterns('portaliArticoli', routes.patterns);
routeRegister.addLinks('portaliArticoli', links);

export default list;
